// src/components/SidebarComp.js
import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeIcon from '@mui/icons-material/Home';
import UsersIcon from '@mui/icons-material/GroupRounded';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import logo from '../../utils/images/logo.png';
import { Box} from '@mui/material';

import './Styles.scss';
const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'space-between',
}));
const SidebarComp =  ({ open, toggleSidebar }) => {
  const theme = useTheme();
  const [openn, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
      },
    }}
    variant="persistent"
    anchor="left"
    open={open}
  >
      <DrawerHeader>
        <Box className="sidebarLogo"><img src={logo} alt='' className='logo-img'/></Box>
          <IconButton onClick={toggleSidebar}>
          
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
      <List>

      <ListItem component={Link} to="/home">
              <ListItemButton>
                <ListItemIcon className='menuIcon'>
                <HomeIcon color='primary'/>
                </ListItemIcon>
                <ListItemText primary="Home" className='menuText'/>
              </ListItemButton>
            </ListItem>


            <ListItem component={Link} to="/users">
              <ListItemButton>
                <ListItemIcon className='menuIcon'>
                <UsersIcon color='primary'/>
                </ListItemIcon>
                <ListItemText primary="Users" className='menuText'/>
              </ListItemButton>
            </ListItem>

            <ListItem component={Link} to="/report">
              <ListItemButton>
                <ListItemIcon className='menuIcon'>
                <ReceiptLongOutlinedIcon color='primary'/>
                </ListItemIcon>
                <ListItemText primary="Report" className='menuText'/>
              </ListItemButton>
            </ListItem>


        
      </List>
    </Drawer>
  );
};

export default SidebarComp;
